export default "__VITE_ASSET__CkW6dDV___"